/*
 * This file is generated by generate_webpack_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {ForYouLanding} from "../../for_you/views/ForYouLanding";
const route = [{webpackEntry: "weFindForYou", path: rpAppPath.weFindForYou.base, component: ForYouLanding}];

(function () {
    rpClient(route);
})();
/*
 * This file is generated by generate_webpack_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {ForYouLanding} from "../../for_you/views/ForYouLanding";
const route = [{webpackEntry: "weFindForYou", path: rpAppPath.weFindForYou.base, component: ForYouLanding}];

(function () {
    rpClient(route);
})();
